<template>
  <div class="row no-gutters m-0">
    <!--<div class="trigger-screen"></div>-->
    <div class="col-md-6 bg-lite mt-join-height">
      <div class="mt-join-collection-card preview-invitation-container">
        <div class="mt-join-collection-card-inner text-center" style="box-shadow: 0px 0px 34.5711px rgba(0, 0, 0, 0.15);">
          <div v-if="invitationHtml?.length > 0" v-html="invitationHtml">
            
          </div>

          <img v-else class="card-bg" :src="this.collection.collectionImage" alt=""/>

        </div>
        <div class="mt-join-collection-card-footer text-center">
          <svg viewBox="0 0 136 58" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.509 30.914c4.142 0 7.509-3.397 7.509-7.509V8.21h-2.98v1.579S10.34 8 7.48 8C3.248 8 0 11.367 0 15.598c0 4.232 3.248 7.569 7.48 7.569 2.86 0 4.558-1.788 4.558-1.788v2.026a4.508 4.508 0 01-4.53 4.53c-1.22 0-2.383-.447-3.217-1.312L2.205 28.71c1.4 1.43 3.278 2.205 5.304 2.205zm-.03-10.727c-2.503 0-4.5-2.116-4.5-4.589 0-2.503 1.997-4.618 4.5-4.618s4.589 2.115 4.589 4.618c0 2.473-2.086 4.59-4.589 4.59zM18.453 22.958h2.98v-8.283c.09-2.086 1.699-3.844 3.755-3.844.774 0 1.52.268 2.145.685l1.132-2.86A6.843 6.843 0 0025.485 8c-2.77 0-4.052 1.967-4.052 1.967V8.209h-2.98v14.75zM36.243 23.167c4.172 0 7.48-3.337 7.48-7.569 0-4.26-3.308-7.598-7.48-7.598-4.172 0-7.48 3.337-7.48 7.598 0 4.232 3.308 7.569 7.48 7.569zm0-2.98c-2.503 0-4.5-2.235-4.5-4.589 0-2.503 2.086-4.618 4.5-4.618s4.5 2.115 4.5 4.618c0 2.473-2.116 4.59-4.5 4.59zM53.26 23.167c4.171 0 6.853-2.712 6.853-6.883V8.209h-2.98v8.313c0 2.384-1.49 3.904-3.874 3.904-2.383 0-3.873-1.52-3.873-3.904V8.21h-2.98v8.075c0 4.171 2.682 6.883 6.853 6.883zM63.543 30.706h2.98v-9.327s1.698 1.788 4.559 1.788c4.171 0 7.479-3.337 7.479-7.598 0-4.232-3.308-7.569-7.48-7.569-2.86 0-4.558 1.788-4.558 1.788v-1.58h-2.98v22.498zm7.539-10.519c-2.563 0-4.589-2.056-4.589-4.618 0-2.474 2.026-4.59 4.589-4.59 2.562 0 4.5 2.116 4.5 4.59 0 2.562-1.938 4.618-4.5 4.618z"></path>
            <path
                d="M27.94 24.031l.354.344c2.045 1.983 4.872 3.212 7.998 3.212 3.126 0 5.953-1.229 7.998-3.212l.354-.344 2.185 2.119-.377.365C43.85 29.04 40.257 30.6 36.292 30.6s-7.558-1.56-10.16-4.084l-.377-.365 2.184-2.119z"
                class="text-turquoise-100 fill-current theme-color">
            </path>
            <path
                d="M21.366 49.985h2.98V38.006h2.71v-2.83h-2.71v-6.803h-2.98v6.802h-2.712v2.831h2.712v11.979zM36.246 50.163c4.172 0 7.48-3.337 7.48-7.568 0-4.261-3.308-7.599-7.48-7.599-4.171 0-7.479 3.338-7.479 7.599 0 4.231 3.308 7.568 7.48 7.568zm0-2.98c-2.503 0-4.499-2.234-4.499-4.588 0-2.503 2.086-4.619 4.5-4.619 2.413 0 4.499 2.116 4.499 4.619 0 2.473-2.116 4.589-4.5 4.589zM53.471 57.91c4.142 0 7.51-3.396 7.51-7.508V35.205H58v1.58s-1.699-1.788-4.56-1.788c-4.23 0-7.479 3.367-7.479 7.598s3.248 7.568 7.48 7.568c2.86 0 4.559-1.787 4.559-1.787v2.026a4.508 4.508 0 01-4.53 4.529c-1.221 0-2.383-.447-3.218-1.311l-2.086 2.086c1.401 1.43 3.278 2.205 5.304 2.205zm-.03-10.726c-2.502 0-4.499-2.116-4.499-4.59 0-2.502 1.997-4.618 4.5-4.618s4.588 2.116 4.588 4.619c0 2.473-2.085 4.589-4.588 4.589zM71.197 50.163a7.42 7.42 0 005.334-2.234l-2.176-2.116c-.864.894-1.966 1.37-3.158 1.37-1.997 0-3.785-1.34-4.261-3.337H78.39c0-5.631-3.023-8.85-7.194-8.85-4.172 0-7.45 3.338-7.45 7.599 0 4.231 3.278 7.568 7.45 7.568zm-4.261-9.147c.625-1.788 2.085-3.04 4.171-3.04 2.086 0 3.695 1.341 4.142 3.04h-8.313zM82.894 49.985h2.98V38.006h2.712v-2.83h-2.712v-6.803h-2.98v6.802h-2.711v2.831h2.711v11.979zM91.114 49.955h2.98v-7.747c0-2.355 2.115-4.291 4.469-4.291 2.503 0 4.321 1.936 4.321 4.44v7.598h2.979v-7.45c0-4.171-2.92-7.509-7.091-7.509-3.189 0-4.679 1.967-4.679 1.967v-8.59h-2.98v21.582zM115.854 50.163a7.418 7.418 0 005.333-2.234l-2.175-2.116c-.864.894-1.967 1.37-3.158 1.37-1.997 0-3.785-1.34-4.261-3.337h11.71c0-5.631-3.278-8.85-7.449-8.85-4.172 0-7.45 3.338-7.45 7.599 0 4.231 3.278 7.568 7.45 7.568zm-4.261-9.147c.625-1.788 2.085-3.04 4.171-3.04 2.086 0 3.695 1.341 4.142 3.04h-8.313zM125.988 49.955h2.98V41.67c.089-2.086 1.698-3.844 3.754-3.844.775 0 1.52.268 2.146.686L136 35.652a6.843 6.843 0 00-2.98-.656c-2.771 0-4.052 1.967-4.052 1.967v-1.758h-2.98v14.75z"></path>
          </svg>
        </div>
      </div>
    </div>
    <!-- md-6 -->
    <div class="col-md-6 bg-white d-flex justify-content-center align-items-center">
        <div class="mt-join-collection-card-content max-440 contributorPayment-btns w-100 text-center">
            <h1>
                {{ this.collection.subtitle }}<span class="d-block d-md-none"></span>
            </h1>
            <p class="d-block d-md-none">Closes on {{ this.collection.closeDate }}</p>
            <!--<h5 style=" color: #606060; font-size: 20px;font-weight: 300; max-width: 600px; margin: 30px auto; padding: 0 20px;line-height: 28px;">
                Thank You for your interest. The collection has met its target amount, please contact the organiser for further information on how to contribute to the gift.
            </h5>-->
            <h5 v-if="(this.collection.collectionSetupType === 'Collection' || this.collection.collectionSetupType === 'Collection + Group Card') && this.collection.soFarCollection >= 2000"
                style=" color: #606060; font-size: 20px;font-weight: 300; max-width: 600px; margin: 30px auto; padding: 0 20px;line-height: 28px;">
                Collections cannot exceed $2000.
            </h5>
            <div v-else-if="this.collection.collectionSetupType === 'Collection'" class="row justify-content-center">
                <div class="col-md-6">
                    <a href="javascript:void(0)" class="theme-btn-lite max-290 ml-auto mr-auto" @click="$emit('showHideDiv', 'showPaymentScreen')">Chip In</a>
                </div>
            </div>

        <div v-else-if="this.collection.collectionSetupType === 'Group Card Only' || this.collection.collectionSetupType === 'FGC + Gift'" class="row justify-content-center">
          <div class="col-md-6">
            <a href="javascript:void(0)" class="theme-btn-lite" @click="$emit('showHideDiv','showGroupCard')">Sign</a>
          </div>
        </div>

            <div v-else-if="this.collection.collectionSetupType === 'Collection + Group Card'" class="row">
                <div class="col-md-12">
                    <a href="javascript:void(0)" class="theme-btn-lite max-290 ml-auto mr-auto" @click="$emit('showHideDiv', 'showGroupCard')">
                        Sign & Chip In
                    </a>
                </div>
                <div v-if="this.collection.zeroContributionAllowed" class="col-md-12">
                    <a href="javascript:void(0)" class="simple-link" @click="$emit('showHideDiv', 'signonly')">Sign only</a>
                </div>
            </div>

            <p class="d-none d-md-block" v-if="this.collection.closeDate">Closes {{ this.collection.closeDate }}</p>
        </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ContributionFirstPage",
  components: {},
  props: ['collection', 'hasSession', 'hasGroupCard', 'showHideDiv'],
  data() {
    return {
      invitationHtml: ''
    }
  },
  async beforeMount() {
      await this.modelData();
   },
  methods: {
      async modelData() {
          const url = `${window.location.origin}/api/contributions/contribution-first-page-details?collectionId=${this.$route.query.collection}`;
      await this.axios.get(url)
          .then((resp) => {
              const { InvitationHtml } = resp.data;
              this.invitationHtml = InvitationHtml;

          })
          .catch((err) => {
            console.log(err);
              alert(JSON.stringify(err.response.data.errors));
             
          })
      }
      
  }
}
</script>

<style scoped>

</style>